module.exports = __webpack_public_path__ + "img/2.cafe47db.png";